import type { IProcedures } from '@phi/procedures';
import type { Result } from '@vaaas/fpts/result';
import app from '@frontend/application-container';
import { make_json_rpc_caller } from '@phi/rpc/json-rpc-frontend';

/** adds authorization header to all outgoing http requests */
export const fetch_with_auth = (x: Request): Promise<Response> => {
    x.headers.set('Authorization', `Bearer ${app.deviceStorage.token}`);
    return fetch(x);
};

export const only_when_authorised = <A extends any[], B>(f: (...xs: A) => Promise<B>) => (...xs: A): Promise<Result<B>> =>
    app.deviceStorage.token
        ? f(...xs)
        : Promise.resolve(new Error('User is not yet authorized to make any requests'));

export type APICallerFactory = typeof helper;

export const helper = make_json_rpc_caller<IProcedures>({
    base_url: '/api/rpc',
    http: fetch_with_auth,
});
